import { ContentBlock, ContentState, EditorState, Modifier, SelectionState } from 'draft-js';
import * as chrono from 'chrono-node';
import entityAtChar from '../utils/entityAtChar';
import followupFromParsedResult from '../utils/followupFromParsedResult';

function forgetFollowupsInBlock(
  contentState: ContentState,
  block: ContentBlock,
  parsedResults: Array<chrono.ParsedResult>,
  checkForEntity: boolean,
): ContentState {
  return parsedResults.reduce((contentState, parsedResult) => {
    const followup = followupFromParsedResult(parsedResult);
    const followupStart = parsedResult.index;
    const followupEnd = followupStart + followup.text.length;
    let shouldForget = true;

    if (checkForEntity) {
      block.findEntityRanges(
        (char) => {
          const entity = entityAtChar(char, contentState);
          return entity.isFollowupEntity || entity.isMentionEntity;
        },
        (begin, end) => {
          if (
            (shouldForget && begin >= followupStart && begin <= followupEnd) ||
            (end >= followupStart && end <= followupEnd)
          ) {
            shouldForget = false;
          }
        },
      );
    }

    if (shouldForget) {
      const contentStateWithSkipParsingEntity = contentState.createEntity(
        'skipFollowupParsing',
        'MUTABLE',
      );
      const entityKey = contentStateWithSkipParsingEntity.getLastCreatedEntityKey();
      const selection = SelectionState.createEmpty(block.getKey()).merge({
        anchorKey: block.getKey(),
        anchorOffset: followupStart,
        focusKey: block.getKey(),
        focusOffset: followupEnd,
      });
      const contentWithEntitiesRemoved = Modifier.applyEntity(
        contentStateWithSkipParsingEntity,
        selection,
        null,
      );

      return Modifier.replaceText(
        contentWithEntitiesRemoved,
        selection,
        followup.text,
        null,
        entityKey,
      );
    }

    return contentState;
  }, contentState);
}

export default function forgetParsableFollowups(
  editorState: EditorState,
  hasFollowupEntity: boolean,
): EditorState {
  const contentState = editorState.getCurrentContent();
  const contentBlocks = contentState.getBlocksAsArray();
  const newContentState = contentBlocks.reduce((contentState, block) => {
    const blockText = block.getText();
    const parsedNLPDates = chrono.parse(blockText);

    if (parsedNLPDates.length) {
      return forgetFollowupsInBlock(contentState, block, parsedNLPDates, hasFollowupEntity);
    }

    return contentState;
  }, contentState);
  const newEditorState = EditorState.push(editorState, newContentState, 'apply-entity');

  return newEditorState;
}
